import { render, staticRenderFns } from "./disciplinary-actions-table.vue?vue&type=template&id=6526a7f2&scoped=true"
import script from "./disciplinary-actions-table.vue?vue&type=script&lang=js"
export * from "./disciplinary-actions-table.vue?vue&type=script&lang=js"
import style0 from "./disciplinary-actions-table.vue?vue&type=style&index=0&id=6526a7f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6526a7f2",
  null
  
)

export default component.exports